import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { useCallback } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRouterPushWithPrefetch } from "@/hooks/utils/useRouterPushWithPrefetch";
import { signOut } from "@/utils/auth/signOut";
import { clearServiceWorkerAndCaches } from "@/utils/browser/clearServiceWorkerAndCaches";
import styles from "./styles.module.css";

/**
 * Queryなど失敗時に表示するコンポーネント
 */
export const QueryError = () => {
  const $ = _c(10);
  const router = useRouter();
  const handleAuthPush = useRouterPushWithPrefetch("/auth");
  let t0;
  if ($[0] !== handleAuthPush) {
    t0 = async () => {
      ;
      try {
        await signOut();
      } catch (t1) {
        const error = t1;
        console.warn("[QueryError] signOut failed", error);
      }
      await clearServiceWorkerAndCaches({
        logPrefix: "[QueryError]"
      });
      handleAuthPush();
    };
    $[0] = handleAuthPush;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClickLogout = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box display="flex" flexDirection="column" gap="16px"><Typography variant="h1" component="p">ブラウザをリロードして再度お試しください。</Typography><Typography variant="h1" component="p">それでも解決しない場合は、ログアウトしてください。</Typography><Typography variant="h1" component="p">どちらのボタンでも解決しない場合は、お手数ですが担当者までご連絡ください。</Typography></Box>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== router) {
    t2 = <Button variant="contained" color="primary" className={styles.button} onClick={() => router.reload()}>リロードする</Button>;
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClickLogout) {
    t3 = <Button variant="contained" color="secondary" className={styles.button} onClick={onClickLogout}>ログアウトする</Button>;
    $[5] = onClickLogout;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className={styles.root}><div className={styles.notification_container}>{t1}<Box display="flex" flexDirection="column" alignItems="center" gap="16px" mt="16px">{t2}{t3}</Box></div></div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};